<template>
  <div>
    <div>
      <label class="form-label">What is the address of the property you would like to register?</label>
      <PropertyInput
        v-if="model.city"
        :city="model.city"
        :show-labels="false"
        :size="size"
        v-model="model.propertyId"
        v-model:property="property"
        :disable-height-limit="disableHeightLimit"
      />
    </div>
    <BCollapse :show="!!model.parcelId">
      <div class="px-1 py-2">
        <AssessorLink v-if="property" :property="property" class="form-label" />
        <label v-else class="form-label">Parcel #{{ model.parcelId }}</label>
      </div>
    </BCollapse>
  </div>
</template>

<script>
import {LicenseEditorModel} from "@/models/LicenseEditorModel";
import BCollapse from "@/components/common/BCollapse.vue";
import PropertyInput from "@/components/common/PropertyInput.vue";
import AssessorLink from "@/components/common/AssessorLink.vue";

export default {
  components: {AssessorLink, PropertyInput, BCollapse},
  props: {
    model: LicenseEditorModel,
    disableHeightLimit: Boolean,
    size: {
      type: String,
      default: () => 'lg'
    }
  },
  emits: ['property-selected'],
  computed: {
    property: {
      get() {
        return this.model.property;
      },
      set(property) {
        this.model.property = property;
        if (property) {
          this.$emit('property-selected');
        }
      }
    }
  }
}
</script>
